'use strict';

angular.module('ClinicApp').directive('profileDelete', function(ClinicService, DoctorService, CurrentUser, OCModalUtil) {
  return {
    scope: {
      profile: '=profileDelete',
      modelType: '=',
      onDelete: '&',
    },
    templateUrl: '/views/directives/_profile-delete.html',
    link: function($scope) {
      if (['clinic', 'doctor'].indexOf($scope.modelType) == -1) {
        throw new Error('DirectiveArgumentError: `profileDelete` invalid modelType: ' + $scope.modelType + '.');
      }
      $scope.formattedModelType = $scope.modelType == 'clinic' ? 'practice' : 'provider';

      $scope.delete = function() {
        const confirmText = `Are you sure you want to delete ${$scope.profile.name}? Please note that you will not be able to restore this ${$scope.formattedModelType}.`;
        OCModalUtil.showModal(
          'confirm',
          confirmText,
        ).then(function() {
          if ($scope.modelType == 'clinic') {
            return ClinicService.removeClinic($scope.profile.id);
          } else {
            return DoctorService.removeDoctor($scope.profile.id);
          }
        })
          .then(function() {
            CurrentUser.update(function() {
              $scope.onDelete();
            });
          });
      };
    },
  };
});
